import React from "react";

import { Grid } from "../../UI/Grid";
import { Button } from "../../UI/Button";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";

interface IProps {
  handleConfirm: VoidFunction;
  handleCancel: VoidFunction;
}

export const TableRowEditOptions: React.FC<IProps> = (props) => (
  <Grid container spacing={1} wrap="nowrap" justifyContent="flex-end">
    <Grid item>
      <ReadOnlyWrapper>
        <Button onClick={props.handleCancel}>Cancel</Button>
      </ReadOnlyWrapper>
    </Grid>
    <Grid item>
      <ReadOnlyWrapper>
        <Button appearance="primary" onClick={props.handleConfirm}>
          Confirm
        </Button>
      </ReadOnlyWrapper>
    </Grid>
  </Grid>
);
